import Repository from './Repository';
const resource = '/auth/v1/merchants/payment_link';

export default {
  postInfo(payload) {
    
    return new Promise((resolve, reject) => {
      Repository.post(`${resource}`, payload)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  getLink(id, payload) {
    return new Promise((resolve, reject) => {
      Repository.post(`${resource}/${id}`, payload)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  getCurrencyList() {
    return new Promise((resolve, reject) => {
      Repository.get(`/v1/currency`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  }
}
